"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  changingStatus: false,
  isProcessing: false
};
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You can not delete an application (except your own) but you can decline it.");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "If you decline it then you should send an email to the applicant explaining why. They may then choose to delete or change the application. In the meantime the application will still be visible on the calendar but it will be scored through.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "This application has previously been declined, but you can choose to reinstate it.");
var _ref4 = /*#__PURE__*/_react.default.createElement("p", null, "This will put the application back into an applied for status");
var _ref5 = /*#__PURE__*/_react.default.createElement("p", null, "You can either accept this yearbook entry or reject it.");
var _ref6 = /*#__PURE__*/_react.default.createElement("p", null, "If you accept it then the application will be locked against further edits by the applicant and will be marked as ready for yearbook.");
var _ref7 = /*#__PURE__*/_react.default.createElement("p", null, "If you reject it then the application will be put back into yearbook data requested status. You should separately send an email to the applicant explaining what further information is required.");
var _ref8 = /*#__PURE__*/_react.default.createElement("p", null, "Yearbook data has been already been requested for this application, but not yet submitted");
var _ref9 = /*#__PURE__*/_react.default.createElement("p", null, "If you decline it at this stage then you should send an email to the applicant explaining why. The application will still be visible on the calendar but it will be scored through and will not be included in any output for the yearbook.");
var _ref10 = /*#__PURE__*/_react.default.createElement("p", null, "You can submit yearbook data instead by first clicking on edit detail");
class ChangeStatus extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onToggleChangingStatus", () => {
      this.setState({
        changingStatus: !this.state.changingStatus
      });
    });
    _defineProperty(this, "_onUpdateStatus", applicationStatusRef => {
      if (this.state.isProcessing) return;
      this.setState({
        isProcessing: true
      });
      this.props.onUpdateStatus(applicationStatusRef).then(() => this.setState(initialState));
    });
    _defineProperty(this, "_getButtonName", existingStatus => {
      switch (existingStatus) {
        case 'APPY':
          return 'Decline';
        case 'DECL':
          return 'Re-instate';
        case 'SUBM':
          return 'Accept/Reject';
        case 'REQ':
          return 'Decline';
      }
    });
    _defineProperty(this, "_getModalButtons", existingStatus => {
      switch (existingStatus) {
        case 'APPY':
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            disabled: this.state.isProcessing,
            onClick: () => this._onUpdateStatus('DECL')
          }, "Decline Application");
        case 'DECL':
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            disabled: this.state.isProcessing,
            type: "primary",
            onClick: () => this._onUpdateStatus('APPY')
          }, "Re-instate Application");
        case 'SUBM':
          return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
            disabled: this.state.isProcessing,
            onClick: () => this._onUpdateStatus('COMP')
          }, "Accept"), /*#__PURE__*/_react.default.createElement(_button.default, {
            disabled: this.state.isProcessing,
            onClick: () => this._onUpdateStatus('REQ')
          }, "Reject"));
        case 'REQ':
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            disabled: this.state.isProcessing,
            onClick: () => this._onUpdateStatus('DECL')
          }, "Decline Application");
      }
    });
    _defineProperty(this, "_getAcceptCheckMessage", () => {
      const appDivs = this.props.application.applicationTiers;
      if (appDivs.some(ad => ad.enhancedFee && ad.defaultTier.entryFee)) return 'Warning: Enhanced fees set';
      return null;
    });
    _defineProperty(this, "_getModalText", (existingStatus, acceptText) => {
      switch (existingStatus) {
        case 'APPY':
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref, _ref2);
        case 'DECL':
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref3, _ref4);
        case 'SUBM':
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref5, !acceptText ? null : /*#__PURE__*/_react.default.createElement(_alert.default, {
            type: "danger"
          }, acceptText), _ref6, _ref7);
        case 'REQ':
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref8, _ref9, _ref10);
      }
    });
  }
  render() {
    if (!this.props.userIsCalendarOfficer) return null;
    const application = this.props.application;
    const existingStatus = application.applicationStatusRef;
    if (!['APPY', 'DECL', 'SUBM', 'REQ'].includes(existingStatus)) return null;
    const acceptText = existingStatus !== 'SUBM' ? null : this._getAcceptCheckMessage();
    const today = new Date().toISOString().split('T')[0];
    if (application.calendar.finalisedDate && application.calendar.finalisedDate <= today) return null;
    return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleChangingStatus,
      block: this.props.block,
      type: this.props.type || 'secondary'
    }, this._getButtonName(existingStatus)), !this.state.changingStatus ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: application.competitionName,
      onClose: this._onToggleChangingStatus,
      buttons: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
        disabled: this.state.isProcessing,
        onClick: this._onToggleChangingStatus
      }, "Cancel"), this._getModalButtons(existingStatus))
    }, this._getModalText(existingStatus, acceptText)));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(ChangeStatus, "partialQueries", {
  Application: {
    id: true,
    applicationStatusRef: true,
    competitionName: true,
    calendar: {
      finalisedDate: true
    },
    applicationTiers: {
      enhancedFee: true,
      defaultTier: {
        entryFee: true
      }
    }
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(ChangeStatus, undefined, (client, props) => ({
  onUpdateStatus(applicationStatusRef) {
    return client.update('Application.updateStatus', {
      applicationID: props.application.id,
      applicationStatusRef
    });
  }
}));